<footer class="footer-59391 mt-4" style="background-color: #E5E5E5;">

  <div class="container pt-4">

    <div class="row">

      <div class="col-12 col-sm-4" id="name">

        <h2>Crunch <a class="text-primary">Media</a>works</h2>

      </div>

      <div class="col-12 col-sm-4" id="policy">

        <ul class="nav-links list-unstyled nav-left pt-2" style="display: flex; justify-content: center;">

          <li>
            <a href="https://www.crunchmediaworks.com/terms_of_service.html" target="_blank" style="color: black;">
              Terms of Service
            </a>
          </li>

          <li><a href="https://www.crunchmediaworks.com/privacy_policy.html" target="_blank" style="color: black;">Privacy Policy</a></li>
        </ul>


      </div>

      <div class="col-12 col-sm-4 pb-4" id="menus">

        <ul class="nav-links list-unstyled nav-left pt-2" style="display: flex;">

          <li><a href="https://www.optimusdrive.ai/" target="_blank" style="color: black;">Home</a></li>
          <li><a href="https://www.crunchmediaworks.com/team.html" target="_blank" style="color: black;">Team</a></li>
          <li><a href="https://www.crunchmediaworks.com/careers.html" target="_blank" style="color: black;">Jobs</a></li>
          <li><a href="https://www.crunchmediaworks.com/press_mentions.html" target="_blank" style="color: black;">Press</a></li>
          <li><a href="https://dashboard.crunchmediaworks.com/#/authentication/signup" target="_blank" style="color: black;">Try Our API's</a>
          </li>
        </ul>

      </div>

    </div>

  </div>


  <div class="text-center" style="background-color: white;  padding-top: 1.5rem;  padding-bottom: 1rem; ">

    <p><small>Copyright © {{ currentYear }} Crunch Mediaworks</small></p>

  </div>






</footer>